export const isCapsOn = {
  data() {
    return {
      MX_isCapsLockOn: false
    }
  },
  methods: {
    // handle keyboard events for caps lock
    MX_capsLockHandler (e) {
      this.MX_isCapsLockOn = e.getModifierState('CapsLock');
    }
  }
};
